import { isFarmBasedPolicyType, policyTypes } from '@ourbranch/policy-types';

export const illustrationForPolicyType = (type) => {
  if (!Object.values(policyTypes).includes(type)) {
    return null;
  }
  if (isFarmBasedPolicyType(type) || type === policyTypes.FABundle) {
    return 'farm';
  }
  if (type.includes(policyTypes.Home)) {
    return 'home';
  }
  if (type.includes(policyTypes.Condo)) {
    return 'condo';
  }
  if (type.includes(policyTypes.Renters)) {
    return 'renters';
  }
  if (type === policyTypes.Auto) {
    return 'auto';
  }
  return null;
};
